import { MeasureData } from "../../utils/interfaces";
const floor = (value: number): number => {
    return Math.floor(value ) ;
}
export const getBfValues = (measurements: MeasureData['measurements'], gender: 'male' | 'female', unit: 'mm' | 'cm') => {
    const waist = (gender === 'female' ? measurements.waist_female : measurements.waist) / 2.54;

    const neck = measurements.neck / 2.54;
    const height = measurements.height / 2.54;

    const hip = measurements.buttocks / 2.54;
    if (unit === 'mm') {
        console.log("is mm")
        return { waist: waist / 10.0, neck: neck / 10.0, height: height / 10.0, hip: hip / 10.0 };
    }
    return { waist: floor(waist), neck: floor(neck), height: floor(height), hip: floor(hip) };
}

// Add this function to calculate body fat percentage
export const calculateBodyFat = (measurements: MeasureData['measurements'], gender: 'male' | 'female', unit: 'mm' | 'cm' = 'mm'): number => {
    // Example calculation logic, replace with actual logic

    let { waist, neck, height, hip } = getBfValues(measurements, gender, unit);

    if (gender === "male") {
        return (
            86.01 * Math.log10(waist - neck) - 70.041 * Math.log10(height) + 36.76
        );
    } else {
        return (
            163.205 * Math.log10(waist + hip - neck) -
            97.684 * Math.log10(height) -
            78.387
        );
    }
};
